import React from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import {
  sortCaret,
  headerSortingClasses,
  PleaseWaitMessage,
  NoRecordsFoundMessage,
} from "../../../../_metronic/_helpers";
import { sizePerPageList } from "../../../utility";

export const PlantTable = ({
  data,
  page,
  sizePerPage,
  onTableChange,
  totalSize,
  loading,
}) => {
  const columns = [
    {
      text: "Plant Code",
      dataField: "plantCode",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Plant Name",
      dataField: "plantName",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Update User",
      dataField: "updatedUser",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
  ];

  const options = {
    page: page,
    sizePerPage: sizePerPage,
    showTotal: true,
    totalSize: totalSize,
    sizePerPageList: sizePerPageList,
  };

  return (
    <BootstrapTable
      remote
      wrapperClasses="table-responsive"
      classes="table table-head-custom table-vertical-center overflow-hidden"
      bootstrap4
      bordered={false}
      keyField="customerId"
      data={data === null ? [] : data}
      columns={columns}
      pagination={paginationFactory(options)}
      onTableChange={onTableChange}
    >
      <PleaseWaitMessage entities={loading ? null : data} />
      <NoRecordsFoundMessage entities={loading ? null : data} />
    </BootstrapTable>
  );
};
